import { render } from "./MdWarningIcon.vue?vue&type=template&id=119465b4"
import script from "./MdWarningIcon.vue?vue&type=script&lang=js"
export * from "./MdWarningIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__